(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoan-help-agent"] && !Shopify.designMode) return;
  try {
    
  class YoanHelpAgent extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.closeButton = this.querySelector('.help-emoji__close');
      this.closeButton?.addEventListener('click', () => {
        this.details.open = false;
        this.querySelector('summary')?.focus();
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.querySelector('summary')?.focus();
        }
      });
    }
  }

  if (!customElements.get('yoan-help-agent')) {
    customElements.define('yoan-help-agent', YoanHelpAgent);
  }

  } catch(e) { console.error(e); }
})();
})();
